import { useEffect, useRef } from "react"

import { getAccessToken } from "@/lib/auth"
import { registrarHeartbeat, sairPresenca } from "@/modules/admin/services/presencaApi"
import { useSessionStore } from "@/stores/sessionStore"

const INTERVALO_MS = 60_000

/**
 * Envia heartbeat de presença enquanto há sessão autenticada (o backend
 * mantém a chave viva por ~3x o intervalo). Melhor esforço: falhas são
 * silenciosas — a aba "Usuários logados" degrada para menos entradas.
 */
export function PresencaHeartbeat() {
  const autenticado = useSessionStore((s) => s.authenticated)
  const tipo = useSessionStore((s) => s.tipo)
  const tokenRef = useRef<string | null>(null)

  useEffect(() => {
    // Presença é recurso interno; cidadão gov.br não tem sessão no SIGI.
    if (!autenticado || tipo !== "INTERNO") return

    const bater = () => {
      const token = getAccessToken()
      if (!token) return
      tokenRef.current = token
      void registrarHeartbeat().catch(() => undefined)
    }

    bater()
    const id = window.setInterval(bater, INTERVALO_MS)

    // Aba oculta tem timers limitados pelo browser: ao voltar, bate na hora.
    const aoFicarVisivel = () => {
      if (document.visibilityState === "visible") bater()
    }
    // pagehide cobre fecho de aba e o logout (que navega para fora do SPA).
    const aoSair = () => {
      void sairPresenca(tokenRef.current)
    }

    document.addEventListener("visibilitychange", aoFicarVisivel)
    window.addEventListener("pagehide", aoSair)
    return () => {
      window.clearInterval(id)
      document.removeEventListener("visibilitychange", aoFicarVisivel)
      window.removeEventListener("pagehide", aoSair)
      void sairPresenca(tokenRef.current)
    }
  }, [autenticado, tipo])

  return null
}
